import React from 'react';
import { FadeIn } from './FadeIn';
import { GraduationCap } from 'lucide-react';
export function Education() {
  const education = [{
    degree: 'Master Certification in Project Management',
    institution: 'Stevens Institute of Technology',
    color: '#00E5FF'
  }, {
    degree: 'Bachelor of Arts',
    institution: 'Rutgers University, Rutgers College',
    color: '#7C3AED'
  }, {
    degree: 'Associate of Arts',
    institution: 'New York University',
    color: '#E11D74'
  }];
  return <section id="education" className="relative py-24 md:py-32 bg-navy border-t border-white/5 overflow-hidden" data-id="element-64">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full opacity-15 blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(124,58,237,0.5) 0%, transparent 70%)'
    }} data-id="element-65"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-66">
        <FadeIn data-id="element-67">
          <div className="mb-16 md:mb-20" data-id="element-68">
            <div className="text-xs uppercase tracking-widest font-medium mb-6" style={{
            background: 'linear-gradient(90deg, #C8A96A, #7C3AED)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }} data-id="element-69">
              Education &amp; Training
            </div>
            <h3 className="text-3xl md:text-4xl lg:text-5xl font-serif text-softwhite leading-tight max-w-3xl" data-id="element-70">
              Academic foundations of a{' '}
              <span style={{
              background: 'linear-gradient(135deg, #C8A96A, #7C3AED)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }} data-id="element-71">
                disciplined
              </span>{' '}
              career.
            </h3>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6" data-id="element-72">
          {education.map((item, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-73">
              <div className="group relative h-full p-8 md:p-10 rounded-2xl bg-white/[0.03] backdrop-blur-sm border border-white/10 hover:border-white/30 transition-all duration-500 overflow-hidden" data-id="element-74">
                <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full opacity-20 blur-2xl group-hover:opacity-50 transition-opacity duration-500" style={{
              background: `radial-gradient(circle, ${item.color} 0%, transparent 70%)`
            }} data-id="element-75"></div>
                <div className="relative mb-6" style={{
              color: item.color
            }} data-id="element-76">
                  <GraduationCap strokeWidth={1.25} className="w-8 h-8" data-id="element-77" />
                </div>
                <h4 className="relative text-lg font-serif text-softwhite mb-3 leading-snug" data-id="element-78">
                  {item.degree}
                </h4>
                <p className="relative text-softwhite/60 text-sm font-light" data-id="element-79">
                  {item.institution}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}